import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import {CloneConfirmationDialogComponent} from './clone-confirmation-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [CloneConfirmationDialogComponent],
  imports: [CommonModule, ModalModule.forRoot(),
    TranslateModule.forChild()],
  exports: [CloneConfirmationDialogComponent],
})
export class CloneConfirmationDialogModule { }
